/* Himmelpfort Produktseite · dynamischer Preis pro Tasse */

(function () {
  'use strict';

  if (window.__hkProductTopScriptInitialized) return;
  window.__hkProductTopScriptInitialized = true;

  function formatMoney(cents, currencyCode, locale) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currencyCode
    }).format(Number(cents || 0) / 100);
  }

  function getProductInfo(root) {
    return root.closest('.product-info');
  }

  function getSelectedPurchaseMode(root) {
    var productInfo = getProductInfo(root);
    if (!productInfo) return '';

    var checkedRadios = productInfo.querySelectorAll('input[type="radio"]:checked');

    for (var i = 0; i < checkedRadios.length; i += 1) {
      var radio = checkedRadios[i];
      var textSource =
        radio.closest('label') ||
        radio.closest('[class*="purchase"]') ||
        radio.closest('[class*="subscription"]') ||
        radio.parentElement;

      var text = textSource
        ? String(textSource.textContent || '').toLowerCase()
        : '';

      var value = String(radio.value || '').toLowerCase();
      var name = String(radio.name || '').toLowerCase();

      if (
        text.indexOf('einmal kaufen') !== -1 ||
        value.indexOf('one') !== -1 ||
        value.indexOf('onetime') !== -1 ||
        value.indexOf('one_time') !== -1 ||
        name.indexOf('one_time') !== -1
      ) {
        return 'one-time';
      }

      if (
        text.indexOf('kaffee-abo') !== -1 ||
        text.indexOf('abo') !== -1 ||
        text.indexOf('subscription') !== -1 ||
        value.indexOf('subscription') !== -1 ||
        value.indexOf('selling_plan') !== -1 ||
        name.indexOf('subscription') !== -1
      ) {
        return 'subscription';
      }
    }

    return '';
  }

  function getSelectedSellingPlan(root) {
    var productInfo = getProductInfo(root);
    if (!productInfo) return '';

    /*
     * Wichtig:
     * Appstle lässt das versteckte selling_plan-Feld teilweise auch dann
     * befüllt, wenn "Einmal kaufen" ausgewählt wurde. Deshalb wird der
     * Selling Plan nur verwendet, wenn die Abo-Auswahl wirklich aktiv ist.
     */
    if (getSelectedPurchaseMode(root) !== 'subscription') {
      return '';
    }

    var checked = productInfo.querySelector(
      'input[name="selling_plan"]:checked'
    );

    if (checked && checked.value) {
      return String(checked.value);
    }

    var select = productInfo.querySelector('select[name="selling_plan"]');

    if (select && select.value) {
      return String(select.value);
    }

    var hidden = productInfo.querySelector(
      'input[name="selling_plan"][type="hidden"]'
    );

    if (hidden && hidden.value) {
      return String(hidden.value);
    }

    var fallback = productInfo.querySelector('[name="selling_plan"]');

    return fallback && fallback.value ? String(fallback.value) : '';
  }

  function getSelectedVariantId(root) {
    var productInfo = getProductInfo(root);
    if (!productInfo) return '';

    var input = productInfo.querySelector(
      '.js-product-form-main input[name="id"]'
    );

    return input && input.value ? String(input.value) : '';
  }

  function update(root) {
    var jsonNode = root.querySelector('[data-hk-variant-prices]');
    var priceNode = root.querySelector('[data-hk-cup-price]');
    var detailsNode = root.querySelector('[data-hk-cup-details]');

    if (!jsonNode || !priceNode || !detailsNode) return;

    var data;

    try {
      data = JSON.parse(jsonNode.textContent);
    } catch (error) {
      return;
    }

    var variantId = getSelectedVariantId(root);
    var variant = data[variantId];

    if (!variant) return;

    var price = Number(variant.price || 0);
    var sellingPlanId = getSelectedSellingPlan(root);

    if (
      sellingPlanId &&
      variant.selling_plans &&
      variant.selling_plans[sellingPlanId] !== undefined
    ) {
      price = Number(variant.selling_plans[sellingPlanId]);
    }

    var grams = Number(variant.weight || 0);
    var dose = Number(root.dataset.doseGrams || 0);
    var yieldLabel = root.dataset.yieldLabel || 'Tassen';
    var currencyCode = root.dataset.currencyCode;
    var locale = root.dataset.locale;

    if (!grams || !dose || !price || !currencyCode || !locale) {
      priceNode.textContent = '–';
      detailsNode.textContent =
        'Für diese Variante fehlen Gewichts- oder Preisdaten.';
      return;
    }

    var exactCups = grams / dose;
    var cups = Math.floor(exactCups);
    var pricePerCup = price / exactCups;

    priceNode.textContent = formatMoney(pricePerCup, currencyCode, locale);
    detailsNode.textContent =
      'Aus dieser Packung bekommst du etwa ' +
      cups +
      ' ' +
      yieldLabel +
      '.';
  }

  function scheduleUpdate(root) {
    window.setTimeout(function () {
      update(root);
    }, 0);

    window.setTimeout(function () {
      update(root);
    }, 100);

    window.setTimeout(function () {
      update(root);
    }, 300);
  }

  function scheduleAllUpdates() {
    document
      .querySelectorAll('[data-hk-product-support]')
      .forEach(scheduleUpdate);
  }

  function init(root) {
    if (root.dataset.hkCupPriceInitialized === 'true') return;

    root.dataset.hkCupPriceInitialized = 'true';

    scheduleUpdate(root);

    var productInfo = getProductInfo(root);
    if (!productInfo) return;

    productInfo.addEventListener('change', function () {
      scheduleUpdate(root);
    });

    productInfo.addEventListener('click', function () {
      scheduleUpdate(root);
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-hk-product-support]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('on:variant:change', scheduleAllUpdates);
  document.addEventListener('on:line-item:change', scheduleAllUpdates);
  document.addEventListener('shopify:section:load', initAll);
})();